import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRangoPesoEstadia = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'rango_peso_estadia',
        name: 'Rango Peso Estadia',
        component: ViewRangoPesoEstadia,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
